import {uiActions} from "../store/ui/slice";
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import useScript from "../hooks/useScript";

const PayTest = () => {

    const [result, setResult] = useState(null);
    const [payResult, setPayResult] = useState(null);
    const dispatch = useDispatch();

    //todo probably move this stuff to a mutation in the cart api or a new payments api
    useEffect(() => {
        // api request for getting commerce hub AccessToken and other credential info
        //dispatch(uiActions.setAlertInfo(onSubmitMsg));
        let request = new XMLHttpRequest();
        request.onload = () => {
            if (request.status >= 200 && request.status < 300) {
                console.log(request);
                setResult(JSON.parse(request.responseText));
            } else {
                dispatch(
                    uiActions.setAlertError(
                        "Failed to process payment. Please try another time."
                    )
                );
            }
            request = null;
        };

        // should be POST request?
        request.open(
            "GET",
            import.meta.env.VITE_API_URL + "authorize_session",
            true
        );
        request.send();
    }, []);

    //test a charge transaction after the credentials are received
    useEffect(async () => {
        if (result) {
            let request = new XMLHttpRequest();
            request.onload = () => {
                if (request.status >= 200 && request.status < 300) {
                    console.log(request);
                    setPayResult(JSON.parse(request.responseText));
                } else {
                    dispatch(
                        uiActions.setAlertError(
                            "Failed to process payment. Please try another time."
                        )
                    );
                }
                request = null;
            };

            request.open(
                "POST",
                import.meta.env.VITE_API_URL + "pay_test",
                true
            );
            request.setRequestHeader('Content-type', 'application/json');
            //RSA encrypt card details
            const encryptedCardData = await encryptCardData(null);
            //include encrypted card details and Commerce Hub access token in the request body
            let body = JSON.stringify({...encryptedCardData, "accessToken": result.accessToken}, null, 4);
            console.log(body);
            request.send(body);
        }
    }, [result]);

    async function encryptCardData (data) {
        const cardData = {
            "cardData": "4141414141414141",
            "nameOnCard": "Joe Bloggs",
            "expirationMonth": "01",
            "expirationYear": "2034",
            "securityCode": "123"
        }

        console.log("Public Key: " + result.publicKey);

        const encryptionBlock = await rsaEncrypt(result.publicKey, Object.values(cardData).join(""));
        const encoder = new TextEncoder();
        const encryptionBlockFields = Object.keys(cardData).map(key => `card.${key}:${encoder.encode(cardData[key]).length}`).join(',');
        const payload = {
            source: {
                sourceType: "PaymentCard",
                encryptionData: {
                    keyId: result.keyId,
                    encryptionType: "RSA",
                    encryptionBlock: encryptionBlock,
                    encryptionBlockFields: encryptionBlockFields,
                    encryptionTarget: "MANUAL",
                }
            }
        };
        console.log(JSON.stringify(payload, null, 4));
        return payload;
    }

    async function rsaEncrypt (base64PubKey, sourceString) {
        const keyBuf = toArrayBuffer(window.atob(base64PubKey));
        const pubKeyDer = await window.crypto.subtle.importKey("spki", keyBuf, { name: "RSA-OAEP", hash: "SHA-256", }, true, ["encrypt"]);
        const encryptedBlock = await window.crypto.subtle.encrypt({name: "RSA-OAEP",}, pubKeyDer, new TextEncoder().encode(sourceString));
        return toBase64Encode(encryptedBlock);
    }

    // Utils
    const toArrayBuffer = (str) => {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0; i < str.length; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    };

    const toBase64Encode = (arrayBuffer) => window.btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));

  return (
    <div>
      <h1>PayTest</h1>
        <p>Result:</p>
        <p>{result && result.accessToken}</p>
    </div>
  );
}

export default PayTest;
